import { Grid, Typography, makeStyles, Theme } from '@material-ui/core'
import { FormattedMessage } from 'react-intl'
import { useFormikContext } from 'formik'
import {
  useProductFromQueryParam,
  shouldRenderPerformanceGuaranteeLink,
  SemiConfigFormValues,
} from '../ProductsConfiguration'
import PerformanceGuaranteeModal from '@src/routes/Configurators/components/PerformanceGuaranteeModal'
import Species from './Species'
import GRnaCategory from './GRnaCategory'
import CircleLoader from '@src/components/CircleLoader'
import PreDesignedControls from './PreDesignedControls'

const useStyles = makeStyles((theme: Theme) => ({
  title: {
    paddingBottom: theme.spacing(1),
    borderBottom: `1px solid ${theme.palette.grey[400]}`,
  },
  instructions: {
    padding: theme.spacing(2, 0),
  },
}))

const SelectClones = () => {
  const product = useProductFromQueryParam()
  const classes = useStyles()
  const renderAdditionalLinkOnStep1 =
    shouldRenderPerformanceGuaranteeLink(product)
  const formik = useFormikContext<SemiConfigFormValues>()

  return (
    <Grid container>
      <Grid item xs={12} container className={classes.title}>
        <Grid item xs={8}>
          <Typography variant="h2">
            <FormattedMessage
              id="CONF_Crispr_Search_Criteria_crisprgrna"
              defaultMessage="Search Criteria"
            />
          </Typography>
        </Grid>
        <Grid
          item
          xs={4}
          container
          justifyContent="flex-end"
          alignItems="baseline"
        >
          {renderAdditionalLinkOnStep1 && <PerformanceGuaranteeModal />}
        </Grid>
      </Grid>
      <Species />
      <GRnaCategory />
      <PreDesignedControls />
      {formik.values?.loading && <CircleLoader />}
    </Grid>
  )
}

export default SelectClones
